import React, { useEffect } from 'react';
import { Stack, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { NotificationsListView } from 'new/elements/Notifications/NotificationsListView';
import { useNotifications } from 'new/hooks/adapters/useNotifications';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_ALL_NOTIFICATIONS_REQUEST } from 'js/constants/actionTypes';
import { MAIN_ALL } from 'js/constants/notificationsTypes';
import { loadAllNotifications } from 'js/actions';
import { Button } from 'new/elements/Button';
import { NotificationSettings } from 'new/components/monitor/NotificationSettings/NotificationSettings';
import { ReactComponent as SettingsIcon } from 'new/components/icons/settings.svg';
import { ReactComponent as BellIcon } from 'new/components/icons/fi-rr-bell-ring.svg';
import { ReactComponent as NotificationsIcon } from 'new/components/icons/bell.svg';
import { NotificationItemSkeleton } from './NotificationItemSkeleton';
import styles from './NotificationsWidget.module.scss';

export const NotificationsWidget = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const isLoading = useIsLoading(GET_ALL_NOTIFICATIONS_REQUEST);
  const { notifications } = useNotifications({ type: MAIN_ALL });

  useEffect(() => {
    dispatch(loadAllNotifications(MAIN_ALL, 20, 0, 1));
  }, []);

  const onClickSettings = () => {
    history.push(NotificationSettings.screenConfig.path as string);
  };

  return (
    <div className={styles.notificationsWidget}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack gap="var(--spacing-sm)">
          <Typography variant="subtitle1" className={styles.notificationsTitle}>
            Notifications
          </Typography>
          <Stack direction="row" alignItems="center" gap="var(--spacing-sm)">
            <NotificationsIcon className={styles.notificationsIcon} />
            <Typography variant="body2" className={styles.notificationsSubtitle}>
              Recent alerts
            </Typography>
          </Stack>
        </Stack>
        <Button onClick={onClickSettings} startIcon={<SettingsIcon />}>
          Settings
        </Button>
      </Stack>
      {isLoading ? (
        <Stack direction="column" gap="var(--spacing-lg)">
          {Array.from({ length: 6 }).map((_, index) => (
            <NotificationItemSkeleton key={`skeleton-${index}`} />
          ))}
        </Stack>
      ) : notifications.length === 0 ? (
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          gap="var(--spacing-lg)"
          className={styles.noNotificationsContainer}
        >
          <BellIcon />
          <Typography variant="bodyLarge" className={styles.noNotificationsTitle}>
            No new notifications
          </Typography>
        </Stack>
      ) : (
        <div className={styles.notificationsListContainer}>
          <NotificationsListView
            items={notifications}
            loading={false}
            showResource={false}
            compact={false}
            hideActions
            className={styles.notificationsList}
          />
        </div>
      )}
    </div>
  );
};
